<div class="row">
  <div class="col-md-12 text-center">
    <div class="alert alert-info"><span class="fa fa-exclamation-circle"></span>{{ 'error_no_details' | translate }}</div>
  </div>
</div>